export default __webpack_public_path__ + "static/media/carousel2.f61ba9ac.png";